'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResults = function (_Component) {
  (0, _inherits3.default)(SearchResults, _Component);

  function SearchResults() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SearchResults);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SearchResults.__proto__ || (0, _getPrototypeOf2.default)(SearchResults)).call.apply(_ref, [this].concat(args))), _this), _this.resultList = function (results, style) {
      return results.map(function (result) {
        var key = result.key,
            primaryVal = result.primaryVal,
            secondaryVal = result.secondaryVal,
            link = result.link;

        var resultBody = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'quiver-search-results__description', style: style && style.description },
            _react2.default.createElement(
              'div',
              { className: 'quiver-search-results__primary', style: style && style.primary },
              primaryVal
            ),
            _react2.default.createElement(
              'div',
              { className: 'quiver-search-results__secondary', style: style && style.secondary },
              secondaryVal
            )
          ),
          result.badge ? _react2.default.createElement(
            'div',
            { className: 'quiver-search-results__badge', style: style && style.badge },
            result.badge
          ) : null
        );

        return _react2.default.createElement(
          'li',
          { key: key, style: style && style.li },
          link ? _react2.default.createElement(
            'a',
            { href: link },
            resultBody
          ) : resultBody
        );
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SearchResults, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          results = _props.results,
          style = _props.style;

      return _react2.default.createElement(
        'ul',
        { className: 'quiver-search-results', style: style },
        this.resultList(results, style)
      );
    }
  }]);
  return SearchResults;
}(_react.Component);

SearchResults.propTypes = {
  results: _propTypes2.default.array,
  style: _propTypes2.default.object
};
SearchResults.defaultProps = {
  results: []
};
exports.default = SearchResults;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/SearchResults/SearchResults.js
// module id = 646
// module chunks = 11